import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../../../../Button'
import { ButtonSelect, ButtonTextSelectControl } from '../../../../../Select'
import { QA_NAME_APPLICANT_CHECKLIST_ATTACH } from '../ApplicantDocumentChecklist.constants'
import {
  getApplicantCreditReportDocumentOptions,
  getApplicantDocumentAttachTooltip,
  getIsApplicantCreditReportRow,
} from '../ApplicantDocumentChecklist.utils'

import * as styles from './ApplicantDocumentChecklistAttach.module.css'

function ApplicantDocumentChecklistAttach({
  isAttaching,
  isLocked,
  row,
  tooltip,
  onAttach,
}) {
  const { t } = useTranslation()

  const isDisabled = Boolean(tooltip) || isLocked

  function handleClickAttach() {
    onAttach({ row })
  }

  function handleSelectDocument(option) {
    onAttach({ documentKey: option.value, row })
  }

  return getIsApplicantCreditReportRow(row) ? (
    <ButtonSelect
      Control={ButtonTextSelectControl}
      className={styles.attachSelect}
      controlProps={{
        buttonProps: {
          Button: Button.Outlined,
          disabled: isDisabled,
          height: BUTTON_HEIGHT_32,
          isGrey: true,
          isLoading: isAttaching,
          qaName: QA_NAME_APPLICANT_CHECKLIST_ATTACH,
          text: t('RentalPortal.ApplicantDocumentAttachBtnKey'),
        },
        getTooltip: getApplicantDocumentAttachTooltip,
        openTooltipText: tooltip,
      }}
      disabled={isDisabled}
      dropdownFloatingConfig={{ maxWidthByRef: false }}
      listProps={{ headerProps: { Search: null } }}
      options={getApplicantCreditReportDocumentOptions(t)}
      onSelectItem={handleSelectDocument}
    />
  ) : (
    <Button.Outlined
      isGrey
      disabled={isDisabled}
      height={BUTTON_HEIGHT_32}
      isLoading={isAttaching}
      qaName={QA_NAME_APPLICANT_CHECKLIST_ATTACH}
      text={t('RentalPortal.ApplicantDocumentAttachBtnKey')}
      tooltip={tooltip}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={handleClickAttach}
    />
  )
}

export default ApplicantDocumentChecklistAttach
